import React from "react";
import { Box } from "./style";
export default props => {
  return (
    <Box
      className={props.className}
      status={props.meta.error && props.meta.error !== "" && "error"}
      alignLeft={props.alignLeft}
    >
      <input
        id={props.input.name}
        type={props.type}
        value={props.input.value}
        onChange={e => props.input.onChange(e.target.value)}
        placeholder={props.placeholder}
        autoFocus={props.autoFocus || false}
        maxLength={props.maxLength}
        disabled={props.disabled}
      />
      {props.meta.error && props.meta.error !== "" && (
        <span className="notice" status="error">
          {props.meta.error}
        </span>
      )}
    </Box>
  );
};
